<div class="l-token-info-container">
  <div class="lt-row">
    <!-- Current Leverage -->
    <div class="lt-col current-leverage">
      <p>{{ "tradable_detail_label_leverage" | translate }}</p>
      <div class="info">
        <div class="icon">
          <div class="leverage">
            @if (vm?.isLong) {
              {{
              LEVERAGED_TOKEN_LONG_ICON_VALUE
              }}
            } @else {
              {{ LEVERAGED_TOKEN_SHORT_ICON_VALUE }}
            }
          </div>
        </div>
        <h3>{{ vm?.currentLeverage | locale_effective_leverage: 2 }}x</h3>
      </div>
    </div>
    <!-- Financial Exposure -->
    <div class="lt-col">
      <div class="heading-tooltip">
        <p> {{ "financial_exposure_leverage" | translate }} </p>
        <div
          class="exposure-tooltip bpi__icon-info"
					[bp-tooltip]="
						(cfdEnabled
							? 'financial_exposure_tooltip_cfd'
							: vm?.isLong
							? 'financial_exposure_tooltip_long'
							: 'financial_exposure_tooltip_short'
						) | translate
					"
        position="bottom"></div>
      </div>
      <div class="info">
        <h3>
          {{
          (vm?.currentLeverage | absolute) * +amountInput
          | fiat_precision_symbol
          : {
          id: vm?.fiat?.getId(),
          currencies: [vm?.fiat],
          symbol: true,
          customPrecision: vm?.fiat?.getPrecisionFiat()
        }
        }}
      </h3>
    </div>
  </div>
</div>

<div class="lt-row">
  <!-- Overnight Fee -->
  <div class="lt-col">
    <p>{{ "overnight_fee" | translate }}</p>
    <div class="info">
      <div class="icon adjust">
        <svg-inline
          src="/assets/images/overnight-fee-icon.svg"
          class="overnight-icon"
          [alt]="'icon_alt_text' | translate" />
      </div>
      <h3>{{ vm?.overnightFee | percent_symbol_precision }}</h3>
    </div>
  </div>
  <!-- Trading Fees -->
  <div class="lt-col">
    <p>{{ "trading_fee_leverage" | translate }}</p>
    <div class="info">
      <div class="trading-fee-icon">
        {{ "trading_fee_free" | translate }}
      </div>
    </div>
  </div>
</div>
</div>
